import { autorun } from 'mobx';
import { useEffect } from 'react';
import { useRootStore } from '@nandosaus/state-management';
import { useRouter } from 'next/router';

import { getLandingPage, removeLandingPage } from '../utils/auth';

const useRedirectIfAuthenticated = () => {
  const { MemberStore } = useRootStore();
  const router = useRouter();

  useEffect(() => {
    const disposer = autorun(() => {
      const { profile } = MemberStore;
      if (profile && profile.mobile) {
        // @TODO: confirm this work with other auth scenarios
        const landingPage = getLandingPage();
        removeLandingPage();
        router.push(landingPage);
      }
    });
    return () => disposer();
  }, [MemberStore, router]);
};

export { useRedirectIfAuthenticated };
